import React from 'react';
import { labelInfo } from '../mock/data';
import { Music, Radio, Zap } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="relative py-24 bg-gradient-to-b from-black via-zinc-950 to-black">
      {/* Background grid pattern */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#0a0a0a_1px,transparent_1px),linear-gradient(to_bottom,#0a0a0a_1px,transparent_1px)] bg-[size:4rem_4rem] opacity-30"></div>
      
      {/* Green accent line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-green-500 to-transparent"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-4">
            ABOUT THE
            <span className="block text-green-400 mt-2 drop-shadow-[0_0_20px_rgba(0,255,136,0.8)]">
              LABEL
            </span>
          </h2>
          <div className="w-24 h-1 bg-green-500 mx-auto mt-6 shadow-[0_0_10px_rgba(0,255,136,0.8)]"></div>
        </div>

        {/* Content Grid */}
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left: Description */}
          <div className="space-y-6">
            <p className="text-gray-300 text-lg leading-relaxed">
              {labelInfo.description}
            </p>
            <p className="text-gray-400 text-base leading-relaxed">
              Numero Uno Sounds is more than just a drum and bass label — it's a community, a movement, and a family. We don't see supporters as numbers or statistics; we see real people who are part of what we're building. While many platforms focus on numbers rising, we focus on family growing. Connection, loyalty, and genuine interaction are at the heart of everything we do. From artists to listeners, everyone involved matters to us, and our mission is to stand above the crowd by building something authentic that people truly feel part of.
            </p>
            <p className="text-gray-400 text-base leading-relaxed">
              We distribute worldwide across all major platforms including Beatport, Spotify, Apple Music, and Amazon Music. Our mission is simple — bring real underground drum and bass to a global audience without compromise.
            </p>
            <div className="pt-4">
              <p className="text-green-400 font-semibold text-lg">
                Est. {labelInfo.established}
              </p>
            </div>
          </div>

          {/* Right: Feature Cards */}
          <div className="grid gap-6">
            <div className="group bg-zinc-900/50 backdrop-blur-sm border border-green-500/20 rounded-xl p-6 hover:border-green-500/60 transition-all duration-300 hover:shadow-[0_0_30px_rgba(0,255,136,0.2)]">
              <div className="flex items-start gap-4">
                <div className="p-3 bg-green-500/10 rounded-lg group-hover:bg-green-500/20 transition-colors">
                  <Music className="w-6 h-6 text-green-400" />
                </div>
                <div>
                  <h3 className="text-white font-bold text-xl mb-2">Worldwide Distribution</h3>
                  <p className="text-gray-400">
                    Available on Beatport, Spotify, Apple Music, Amazon, and more.
                  </p>
                </div>
              </div>
            </div>

            <div className="group bg-zinc-900/50 backdrop-blur-sm border border-green-500/20 rounded-xl p-6 hover:border-green-500/60 transition-all duration-300 hover:shadow-[0_0_30px_rgba(0,255,136,0.2)]">
              <div className="flex items-start gap-4">
                <div className="p-3 bg-green-500/10 rounded-lg group-hover:bg-green-500/20 transition-colors">
                  <Radio className="w-6 h-6 text-green-400" />
                </div>
                <div>
                  <h3 className="text-white font-bold text-xl mb-2">Underground Sound</h3>
                  <p className="text-gray-400">
                    Authentic drum and bass that pushes boundaries and breaks molds.
                  </p>
                </div>
              </div>
            </div>

            <div className="group bg-zinc-900/50 backdrop-blur-sm border border-green-500/20 rounded-xl p-6 hover:border-green-500/60 transition-all duration-300 hover:shadow-[0_0_30px_rgba(0,255,136,0.2)]">
              <div className="flex items-start gap-4">
                <div className="p-3 bg-green-500/10 rounded-lg group-hover:bg-green-500/20 transition-colors">
                  <Zap className="w-6 h-6 text-green-400" />
                </div>
                <div>
                  <h3 className="text-white font-bold text-xl mb-2">High Energy</h3>
                  <p className="text-gray-400">
                    Heavy basslines and explosive energy built to shake the dancefloor.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom accent line */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-green-500 to-transparent"></div>
    </section>
  );
};

export default About;
